import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { FirestoreService } from '../services/firestore.service';
import { map, switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class RutesGuard implements CanActivate {

  constructor(
    private router: Router,
    private auth: AuthService,
    private firestore: FirestoreService
  ) {}

  canActivate(): Observable<boolean> {

    return this.auth.stateAutho().pipe(

      switchMap(user => {
        if (!user) {
          this.router.navigate(['/singin']);
          return of(false);
        }

        // 🔥 Obtener usuario desde Firestore
        return this.firestore.getDoc('users', user.uid).pipe(
          map((userData: any) => {

            if (userData?.admin) {
              return true;
            }

            this.router.navigate(['/']);
            return false;
          })
        );
      })
    );
  }
}
